import React, { useEffect }  from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import SupponetUserTable from '../supponetUser/SupponetUserTable';
import SupponetUserSearch from '../supponetUser/SupponetUserSearch';
import Pagination from '@material-ui/lab/Pagination';
import { Grid } from '@material-ui/core';
import axios from 'axios';
import Common from '../../Common';
import { withCookies } from 'react-cookie';

const styles = () => ({
    paper: {
        width: '95%',
        margin: '5px 5px 5px 50px',
    },
    paging: {
        marginTop: '20px',
        marginBottom: '20px'
    },
});

const displayNum = 20; //1ページあたりの項目数

const SupponetUser = (props) => {
    const { classes, userData, setUserData, cookies } = props;
    const [page, setPage] = React.useState(1); //ページ番号
    const [pageCount, setPageCount] = React.useState(); //ページ数
    const [allItems, setAllItems] = React.useState([]); //全データ
    const [displayedItems, setDisplayedItems] = React.useState([]); //表示データ
    const [allUpdate, setAllUpdate] = React.useState(false);
    //スピナー表示用
    const [isLoading, setIsLoading] = React.useState(true);

    useEffect(() => {
        //検索時は1ページ目に戻る
        setPage(1);
        setAllItems(userData);
        //ページカウントの計算
        setPageCount(Math.ceil(userData.length / displayNum));
        //表示データを抽出
        setDisplayedItems(userData.slice(0, displayNum));
        if(userData.length === 0 ) setAllUpdate(false);
    }, [userData]);

    useEffect(() => {
        setIsLoading(true);
        axios.post(
            `${Common.apiServerUrl()}/api/supponet/user`,
            {
                recordId: '',
                memo: '',
                creationDate: '',
                address: '',
                reportDate: '',
                endFlg: '',
                categoryId: '',
                shubetsuId: '',
            },
            {
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    Authorization: 'Bearer ' + cookies.get('access_token'),
                    'x-suppportcenter-token': cookies.get('token'),
                    'x-jichitai-jichitaiid': cookies.get('x-jichitai-jichitaiid'),
                    'x-jichitai-token': cookies.get('x-jichitai-token'),
                },
                data: {},
            }
        )
        .then(Common.handleErrors)
        .then((res) => {
            if (res.success) {
                if(res.result.length === 0) window.alert('絞り込み条件に合致する結果が⾒つかりませんでした。');
                setUserData(res.result);
            } else {
                window.alert(`code : [${res.type}]\nmessage : ${res.message}`);
            }
        })
        .catch((err) => {
            console.error('SupponetUser.js:get err:' + err.message);
        })
        .finally(()=> {
            setIsLoading(false);
        });
    }, []);

    const handleChange = (event, index) => {
        //ページ移動時にページ番号を更新
        setPage(index);
        //ページ移動時に表示データを書き換える
        setDisplayedItems(allItems.slice(((index - 1) * displayNum), index * displayNum));
    };

    return (
        <React.Fragment>
            <div elevation={3} className={classes.paper} >
                <SupponetUserSearch
                    setData={setUserData}
                    setAllUpdate={setAllUpdate}
                    setIsLoading={setIsLoading}
                />
                <SupponetUserTable
                    datas={displayedItems}
                    allData={allItems}
                    setData={setUserData}
                    allUpdate={allUpdate}
                    setAllUpdate={setAllUpdate}
                    isLoading={isLoading}
                />
                <Grid container item justifyContent ="center" alignItems="center" className={classes.paging}>
                    <Pagination count={pageCount} page={page} size="large" color="primary" onChange={handleChange} />
                </Grid>
            </div>
        </React.Fragment>
    );
};

SupponetUser.propTypes = {
    classes: PropTypes.object.isRequired,
    setUserData: PropTypes.func.isRequired,
    userData: PropTypes.array.isRequired,
};


export default withStyles(styles)(withCookies(SupponetUser));